import React from "react";
import PropTypes from 'prop-types';
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import ComponentWrapper from "./ComponentWrapper";

const ComponentsByType = ({components, label, onSelectComponent, onDeleteComponent, defaultItemLabel}) => {
    return (
        components.length ? (
                <>
                    <div style={{padding: 5}}>
                        <Typography color={"textSecondary"}>
                            {label}
                        </Typography>
                        <Divider/>
                    </div>
                    <div style={{display: 'flex'}}>
                        {components.map(({item, index}) => (
                            <ComponentWrapper
                                type={item.type}
                                label={item.properties ? item.properties.name : defaultItemLabel}
                                onSelect={() => onSelectComponent(item, `otherComponents.${index}`)}
                                onDelete={() => onDeleteComponent(`otherComponents.${index}`, item.type)}
                            />
                        ))}
                    </div>
                </>
            ) :
            <></>
    )
};

export default ComponentsByType

ComponentsByType.propTypes = {
    components: PropTypes.array,
    label: PropTypes.string,
    onSelectComponent: PropTypes.func,
    onDeleteComponent: PropTypes.func,
    defaultItemLabel: PropTypes.string
};